import React, { useState } from 'react';

const CatalogoMuros = () => {
  return (
    <section>
      {/* Estilos para anular el overlay verde de card-style3 y permitir solo el zoom */}
      <style>
        {`
          .card-style3 .card-img::before,
          .card-style3 .card-img::after,
          .card-style3:hover .card-img::before,
          .card-style3:hover .card-img::after {
            background: transparent !important;
            opacity: 0 !important;
            content: none !important;
          }
        `}
      </style>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Conoce nuestra colección de recubrimiento para muros</h2>
        </div>
        <div className="row mt-n1-9">
          {/* Producto 1 */}
          {/*}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-bambu.jpg"
            altText="Muros Carbón de Bambú"
            codigo="Carbón de Bambú"
            tipo="Para Interiores"
            link="/muro-carbon-de-bambu"
            delay="100ms"
          />
          */}
          {/* Producto 2 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-lambrin-convaco.jpg"
            altText="Muro Lambrín Cóncavo"
            codigo="Lambrín Cóncavo"
            tipo="Para Interiores"
            link="/muro-lambrin-concavo"
            delay="200ms"
          />
          
          {/* Producto 4 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-bambu-espejo.jpg"
            altText="Muro Bambú Espejo"
            codigo="Bambú Espejo"
            tipo="Para Interiores"
            link="/muro-bamboo-espejo"
            delay="300ms"
          />
          {/* Producto 5 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-tipo-marmol-pvc.jpg"
            altText="Placa Tipo Mármol de PVC"
            codigo="Tipo Mármol de PVC"
            tipo="Para Interiores"
            link="/muro-placa-tipo-marmol-page"
            delay="400ms"
          />
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-vigueta-wpc.jpg"
            altText="Muro Vigueta WPC"
            codigo="Vigueta WPC"
            tipo="Interior y exterior"
            link="/vigueta-wpc-page"
            delay="400ms"
          />
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-follaje-artificial.jpg"
            altText="Muro Follaje Artificial"
            codigo="Follaje Artificial"
            tipo="Interior y exterior"
            link="#"
            delay="400ms"
          />
          {/* Producto 6 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-deck-sintetico.jpg"
            altText="Muro Deck WPC"
            codigo="Deck Sintético WPC"
            tipo="Interior y exterior"
            delay="400ms"
          />
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-lambrin-wpc.jpg"
            altText="Muro Lambrín WPC"
            codigo="Lambrín WPC"
            tipo="Interior y exterior"
            link="/muro-lambrin-sintetico-page"
            delay="400ms"
          />
          
        </div>
      </div>
    </section>
  );
};

// Componente para cada producto
/*
const Producto = ({ imgSrc, altText, codigo, tipo, delay }) => {
  return (
    <div className={`col-sm-6 col-lg-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="card card-style3 border-0 text-center">
        <div className="card-img position-relative">
          <img src={imgSrc} className="card-img-top" alt={altText} />
        </div>
        <div className="card-body p-1-9">
          <h3 className="h5">{codigo}</h3>
          <p className="text-primary mb-0">{tipo}</p>
        </div>
      </div>
    </div>
  );
};
*/

//Componente corregido con enlace
const Producto = ({ imgSrc, altText, codigo, tipo, delay, link }) => {
  const [hover, setHover] = useState(false);

  return (
    <div className="col-sm-6 col-lg-3 mt-1-9 wow fadeInUp" data-wow-delay={delay}>
      <a 
        href={link} 
        className="text-decoration-none text-reset"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div className="card card-style3 border-0 text-center h-100 d-flex flex-column">
          <div className="card-img position-relative" style={{ height: '400px', overflow: 'hidden' }}>
            <img 
              src={imgSrc} 
              className="card-img-top w-100 h-100" 
              alt={altText}
              style={{ 
                objectFit: 'cover',
                transition: 'transform 0.5s ease',
                transform: hover ? 'scale(1.1)' : 'scale(1)'
              }}
            />
          </div>
          <div className="card-body p-1-9 d-flex flex-column justify-content-center flex-grow-1">
            <h3 className="h5 mb-2">{codigo}</h3>
            <p className="text-primary mb-0">{tipo}</p>
          </div>
        </div>
      </a>
    </div>
  );
};


export default CatalogoMuros;
